import {post, get, patch} from '@/lib/axios';

const course = {
  async activate_course(data) {
    return patch(`/course/activate`, data);
  },
  async finish_course(data) {
    return patch(`/course/deactivate`, data);
  },
  async get_current_courses() {
    let answer = await get(`/courses`, {type: 'current'});
    return answer.data.cards;
  },
  async get_finished_courses() {
    let answer = await get(`/courses`, {type: 'finished'});
    return answer.data.cards;
  },
  async get_new_courses() {
    let answer = await get(`/courses`, {type: 'newcourse'});
    return answer.data.cards;
  },
  async get_course_by_id(id) {
    return get(`/course/${id}`);
  },
  async get_test_history(id) {
    return get(`/course/${id}/tests`);
  },
  async save_course_progress(id, data) {
    return patch(`/course/${id}/save`, data);
  },
  async test_start(id) {
    return post(`/course/${id}/test/start`);
  },
  async save_test_end(id, data) {
    return patch(`/course/${id}/test/end`, data);
  },
  async check_answer(id, data) {
    return post(`/course/${id}/test/check`, data);
  },
  async check_scorm_answer(id, data) {
    return post(`/course/${id}/test/check-scorm`, data);
  },

  async interrupt_course(id, data) {
    return patch(`/course/${id}/test/interrupt`, data);
  },
  async courses_count() {
    return get(`/courses/count`);
  },
  async courses_calendar() {
    return get(`/calendar`);
  },
  async get_certificate(course_passing_id) {
    return get('/course/certificate', {course_passing_id: course_passing_id});
  },
  async courses_count_business_plus() {
    return get(`/courses/count-business-plus`);
  },
  async scorm_test_end(id, data) {
    return patch(`/course/scorm/${id}/test/end`, data);
  },
};

export {course as default};
